import { Badge, Subheading, SurfaceCard } from '../../../../components/ui'
import { TestsCatalogControls } from './TestsCatalogControls'
import { OrderStatusMessage } from './OrderStatusMessage'
import { TestsCatalogTable } from './TestsCatalogTable'
import { TestsCategoryFilter } from './TestsCategoryFilter'
import type { OrderMessageTone, TestCatalogItem, TestCategory, TestSortMode } from './types'

interface TestsCatalogCardProps {
  category: TestCategory
  categories: TestCategory[]
  searchQuery: string
  onSearchQueryChange: (query: string) => void
  sortMode: TestSortMode
  onSortModeChange: (mode: TestSortMode) => void
  popularOnly: boolean
  onTogglePopularOnly: () => void
  hasActiveFilters: boolean
  onResetFilters: () => void
  filtered: TestCatalogItem[]
  orderedCount: number
  orderedTestIds: Set<string>
  orderingTestId: string | null
  onSelectCategory: (category: TestCategory) => void
  onOrderTest: (testId: string) => Promise<void>
  orderMessage: string | null
  orderMessageTone: OrderMessageTone
}

export function TestsCatalogCard({
  category,
  categories,
  searchQuery,
  onSearchQueryChange,
  sortMode,
  onSortModeChange,
  popularOnly,
  onTogglePopularOnly,
  hasActiveFilters,
  onResetFilters,
  filtered,
  orderedCount,
  orderedTestIds,
  orderingTestId,
  onSelectCategory,
  onOrderTest,
  orderMessage,
  orderMessageTone,
}: TestsCatalogCardProps) {
  return (
    <SurfaceCard as="article">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex flex-wrap items-center gap-2">
          <Subheading variant="dashboard">Test catalog</Subheading>
          <Badge variant="zinc">
            {filtered.length} shown
          </Badge>
        </div>

        <Badge variant="zinc">{orderedCount} ordered</Badge>
      </div>

      <TestsCatalogControls
        searchQuery={searchQuery}
        onSearchQueryChange={onSearchQueryChange}
        sortMode={sortMode}
        onSortModeChange={onSortModeChange}
        popularOnly={popularOnly}
        onTogglePopularOnly={onTogglePopularOnly}
        hasActiveFilters={hasActiveFilters}
        onResetFilters={onResetFilters}
      />

      <TestsCategoryFilter
        categories={categories}
        selectedCategory={category}
        onSelectCategory={onSelectCategory}
      />

      <TestsCatalogTable
        filtered={filtered}
        orderedTestIds={orderedTestIds}
        orderingTestId={orderingTestId}
        onOrderTest={onOrderTest}
      />

      <OrderStatusMessage message={orderMessage} tone={orderMessageTone} />
    </SurfaceCard>
  )
}
